module.exports = {"654021100":"吉里于孜镇","654021101":"墩麻扎镇","654021102":"英塔木镇","654021103":"胡地于孜镇","654021104":"巴依托海镇","654021105":"阿热吾斯塘镇","654021106":"萨木于孜镇","654021107":"喀什镇","654021201":"吐鲁番于孜乡","654021202":"喀拉亚尕奇乡","654021203":"武功乡","654021204":"萨地克于孜乡","654021205":"愉群翁回族乡","654021209":"维吾尔玉其温乡","654021212":"麻扎乡","654021213":"温亚尔乡","654021214":"阿乌利亚乡","654021215":"曲鲁海乡","654021400":"青年农场","654021401":"多浪农场","654021501":"兵团七十团中心团场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654021.json
// module id = 3128
// module chunks = 0